import { render } from "./VehicleCatalog.vue?vue&type=template&id=176eea4b&scoped=true"
import script from "./VehicleCatalog.vue?vue&type=script&lang=js"
export * from "./VehicleCatalog.vue?vue&type=script&lang=js"

import "./VehicleCatalog.vue?vue&type=style&index=0&id=176eea4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176eea4b"]])

export default __exports__